export const DATE_UNIT_SEPARATOR = '-';
export const DATE_FORMAT = `MM${DATE_UNIT_SEPARATOR}DD${DATE_UNIT_SEPARATOR}YYYY`;
